module.exports = __webpack_public_path__ + "static/media/hint_correctface.cdbb6c52.png";